import {Injectable} from "@angular/core";
import {Borrower} from "@data/schema/loan-appication/borrower";
import {LoanApplicationConstant} from "@services/loan-application-constant";
import {ReferenceContact} from "@data/schema/loan-appication/reference-contact";
import {REO} from "@data/schema/loan-appication/reo";
import {Assets} from "@data/schema/loan-appication/assets";
import {Liability} from "@data/schema/loan-appication/liabilities";
import {Counselling} from "@data/schema/loan-appication/counselling";
import {Employment} from "@data/schema/loan-appication/employment";
import {EmploymentIncome} from "@data/schema/loan-appication/employment-income";
import {MilitaryDetail} from "@data/schema/loan-appication/military-detail";
import {Address} from "@data/schema/loan-appication/address";
import {Declaration} from "@data/schema/loan-appication/declaration";
import {DemographicGovtQuestions} from "@data/schema/loan-appication/demographic-govt-questions";
import {CurrentIncomeItem} from "@data/schema/loan-appication/current-income-item";
import {CommonConstant} from "@services/common-constant";

@Injectable({
  providedIn: 'root'
})
export class CommonUtilService{
  constructor(private loanApplicationConstatns : LoanApplicationConstant,private commonConstants : CommonConstant) {
  }
  getFlagDesc(questionFlag: boolean){
    if(questionFlag){
      return 'Yes';
    }else{
      return 'No';
    }
  }
  getUniquId(){
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  }
  getNewBorrower(){
    let borr = new Borrower();
    borr.sDemograhics = new DemographicGovtQuestions(1,false)
    borr.sDeclaration = new Declaration(1,false);
    borr.sNearestLivingRelative = new ReferenceContact();
    borr.sMailingAddress = new Address();
    borr.sREO=[];
    borr.sREO.push(new REO());
    borr.sAssets=[];
    borr.sAssets.push(new Assets());
    borr.sLiabilities =[];
    borr.sLiabilities.push(new Liability());
    borr.sCounselling = new Counselling();
    borr.sCurrentEmployments=[];
    const employment = new Employment();
    employment.sCurrentIncomeItems = [];
    const currentIncomeItem = new CurrentIncomeItem();
    //employment.sCurrentIncomeItems.push(currentIncomeItem);
    const preEmployment = new Employment();
    preEmployment.sCurrentIncomeItems = [];
    //preEmployment.sCurrentIncomeItems.push(currentIncomeItem);
    borr.sMailingAddressSameAsCurrentAddressFlag = false;
    borr.sCurrentEmployments.push(employment);
    borr.sPreviousEmployments =[];
    borr.sPreviousEmployments.push(preEmployment);
    borr.sMilitaryDetail = new MilitaryDetail();
    borr.sPreviousAddress=[];
    borr.sCurrentAddress = new Address();
    borr.sPreviousAddress.push(new Address());
    borr.sIncomeAssetVerification=[];
    borr.uiArrow = "Expand";
    borr.sCurrentIncomeItems = [];
    return borr;
   }
  getAddrComponent(place, componentTemplate) {
    let result;

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentTemplate[addressType]) {
        result = place.address_components[i][componentTemplate[addressType]];
        return result;
      }
    }
    return;
  }
  getStreetNumber(place) {
    const COMPONENT_TEMPLATE = { street_number: 'short_name' },
      streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return streetNumber;
  }

  getStreet(place) {
    const COMPONENT_TEMPLATE = { route: 'long_name' },
      street = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return street;
  }

  getCity(place) {
    const COMPONENT_TEMPLATE = { locality: 'long_name' },
      city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return city;
  }
  getLocation(place) {
    const COMPONENT_TEMPLATE = { geometry: 'location' },
      location = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return location;
  }

  getState(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  getDistrict(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_2: 'short_name' },
      state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  getCountryShort(place) {
    const COMPONENT_TEMPLATE = { country: 'short_name' },
      countryShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return countryShort;
  }

  getCountry(place) {
    const COMPONENT_TEMPLATE = { country: 'long_name' },
      country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return country;
  }
  getCounty(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_2: 'short_name' },
      county = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return county;
  }

  getPostCode(place) {
    const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
      postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return postCode;
  }

  getPhone(place) {
    const COMPONENT_TEMPLATE = {
        formatted_phone_number: 'formatted_phone_number'
      },
      phone = this.getAddrComponent(place, COMPONENT_TEMPLATE);
    return phone;
  }
  removeRateQuoteItemsFromSession(){
    sessionStorage.removeItem(this.commonConstants.SessionConstants.PricingResults);
    sessionStorage.removeItem(this.commonConstants.SessionConstants.SelectedRateOption);
    sessionStorage.removeItem(this.commonConstants.SessionConstants.SelectedQuote);
    sessionStorage.removeItem(this.commonConstants.SessionConstants.SelectedProgramme);
  }

}
